"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { cx } from "lib/cx";
import { useState, useEffect } from "react";
import { Bars3Icon, DocumentTextIcon, PencilSquareIcon, PhoneArrowDownLeftIcon } from "@heroicons/react/24/outline";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import TemplatesIcon from "public/assets/templatesIcon.svg";
import MobileDashboardIcon from "public/assets/mobileDashboardIcon.svg";
import Image from "next/image";
import { setAccessToken as changeAccessToken, selectAccessToken, selectIsAuthenticationOpen, setIsAuthenticationOpen } from "lib/redux/uiSlice";
import { trackReferralNavHome } from "lib/analytics";
import { useAppDispatch, useAppSelector, useSaveStateToLocalStorageOnChange, useSetInitialStore } from "lib/redux/hooks";
import { usePathname } from "next/navigation";
// import { Button } from "components/Button";
// import CustomIcon from "components/CustomIcon";
// import CheckScoreIcon from "public/icons/getResumeScore.svg";

const MobileNavbar = t0 => {
  const $ = _c(20);
  const {
    onClose,
    handleAuthClick,
    accessToken
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ChevronRightIcon className="h-4 w-4 text-white" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClose) {
    t2 = <button onClick={onClose} className="absolute -left-2 -top-1 rounded-full bg-[#4E4E4E] p-[2px]">{t1}</button>;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== accessToken) {
    t3 = accessToken && <li><Link href="/dashboard" className="flex items-center gap-2"><MobileDashboardIcon /> Dashboard</Link></li>;
    $[3] = accessToken;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <li><Link href="/resume-builder" className="flex items-center gap-2"><TemplatesIcon /> Templates</Link></li>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <li><button onClick={_temp} className="flex items-center gap-2"><Image height={13} width={13} src="/icons/getResumeScore.svg" alt="Score Check" className="h-3 w-3" />Score Check</button></li>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li><Link href="/referral" className="flex items-center gap-2" onClick={_temp2}><PencilSquareIcon className="h-3 w-3" />Referral</Link></li>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <li><Link href="/resume-writing" className="flex items-center gap-2"><PencilSquareIcon className="h-3 w-3" /> Resume Writing</Link></li>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <li><Link href="/resume-writing/consultation" className="flex items-center gap-2"><PhoneArrowDownLeftIcon className="h-3 w-3" /> Consultation</Link></li>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <li><Link href="/blog" className="flex items-center gap-2"><DocumentTextIcon className="h-3 w-3" /> Blogs</Link></li>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t3) {
    t10 = <ul className="flex flex-col items-start font-montserrat">{t3}{t4}{t5}{t6}{t7}{t8}{t9}</ul>;
    $[11] = t3;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const t11 = accessToken ? "Sign out" : "Sign in";
  let t12;
  if ($[13] !== handleAuthClick || $[14] !== t11) {
    t12 = <button className="btn-gradient mt-1 px-8 py-0 font-poppins" onClick={handleAuthClick}>{t11}</button>;
    $[13] = handleAuthClick;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t10 || $[17] !== t12 || $[18] !== t2) {
    t13 = <div className="relative translate-x-0 transform rounded-2xl bg-white p-2 text-[10px] shadow-2xl transition-transform duration-300">{t2}{t10}{t12}</div>;
    $[16] = t10;
    $[17] = t12;
    $[18] = t2;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  return t13;
};
interface NavbarProps {}
export const Navbar = t0 => {
  const $ = _c(58);
  useSetInitialStore();
  useSaveStateToLocalStorageOnChange();
  useAppSelector(selectIsAuthenticationOpen);
  const pathname = usePathname();
  const [activeTab, setActiveTab] = useState("Home");
  const [isMobileNavVisible, setMobileNavVisible] = useState(false);
  const accessToken = useAppSelector(selectAccessToken);
  const dispatch = useAppDispatch();
  let t1;
  if ($[0] !== pathname) {
    t1 = () => {
      if (pathname === "/") {
        setActiveTab("Home");
      } else {
        if (pathname === "/resume-builder") {
          setActiveTab("Templates");
        } else {
          if (pathname === "/dashboard") {
            setActiveTab("Dashboard");
          } else {
            if (pathname === "/resume-writing") {
              setActiveTab("ResumeWriting");
            } else {
              if (pathname === "/resume-writing/consultation") {
                setActiveTab("Consultation");
              } else {
                if (pathname === "/affiliate") {
                  setActiveTab("Dashboard");
                } else {
                  if (pathname === "/referral") {
                    setActiveTab("Referral");
                  } else {
                    if (pathname === "/blog" || pathname?.startsWith("/blog/")) {
                      setActiveTab("Blogs");
                    } else {
                      if (pathname === "/score-check" || pathname === "select-experience" || pathname === "/upload-resume" || pathname?.startsWith("/score-check/")) {
                        setActiveTab("ScoreCheck");
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    };
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useEffect(t1);
  let t2;
  if ($[2] !== isMobileNavVisible) {
    t2 = () => {
      setMobileNavVisible(!isMobileNavVisible);
    };
    $[2] = isMobileNavVisible;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleMobileNavToggle = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setMobileNavVisible(false);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleCloseMobileNav = t3;
  let t4;
  if ($[5] !== accessToken || $[6] !== dispatch || $[7] !== pathname) {
    t4 = () => {
      if (accessToken) {
        localStorage.removeItem("access-token");
        dispatch(changeAccessToken(null));
        if (pathname === "/dashboard") {
          window.location.href = "/";
        } else {
          if (pathname?.startsWith("/resume-writing")) {
            window.location.href = "/resume-writing";
          } else {
            window.location.href = "/";
          }
        }
      } else {
        dispatch(setIsAuthenticationOpen(true));
      }
    };
    $[5] = accessToken;
    $[6] = dispatch;
    $[7] = pathname;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleAuthClick = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cx("fade-in-navbar sticky top-5 z-50 mx-4 mb-5 flex h-[60px] items-center rounded-2xl bg-white px-6 text-base xl:text-lg shadow-sm shadow-[#0000000D] md:mx-8", "relative");
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="sr-only">ResumeMate</span>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="relative h-[28px] w-[24px] md:h-[35px] md:w-[30px] lg:h-[42px] lg:w-[36px] 2xl:h-[51px] 2xl:w-[44px]"><Image src="/assets/resumemateLogo.png" alt="ResumeMate" fill={true} loading="eager" sizes="40px" /></div>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-[#1C75BC]">Resume</span>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex items-center gap-24"><Link href="/">{t6}<div className="flex items-center gap-1 lg:gap-2">{t7}<div className="font-montserrat text-[10px] font-semibold leading-3 md:text-xs md:leading-3 lg:text-xs lg:leading-3 xl:text-sm xl:leading-4 2xl:text-base 2xl:leading-4">{t8} <br /><span className="text-[#27AAE1]">Mate.io</span></div></div></Link></div>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Bars3Icon className="h-6 w-6" />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== handleMobileNavToggle) {
    t11 = <button onClick={handleMobileNavToggle} className="block lg:hidden">{t10}</button>;
    $[15] = handleMobileNavToggle;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = `${activeTab === "Home" ? "font-semibold text-[#52A1FF]" : "font-normal"}`;
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Link href="/">Home</Link>;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t12) {
    t14 = <li className={t12}>{t13}</li>;
    $[18] = t12;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <li className="cursor-pointer"><Link href="/resume-builder">Templates</Link></li>;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  const t16 = `${activeTab === "ScoreCheck" ? "font-semibold text-[#52A1FF]" : "font-normal"}`;
  let t17;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <button onClick={_temp3} className="flex items-center gap-1.5"><span>Score Check</span></button>;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t16) {
    t18 = <li className={t16}>{t17}</li>;
    $[22] = t16;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== accessToken || $[25] !== activeTab) {
    t19 = accessToken && <li className={`${activeTab === "Affiliate" ? "font-semibold text-[#52A1FF]" : "font-normal"}`}><Link href="/dashboard">Dashboard</Link></li>;
    $[24] = accessToken;
    $[25] = activeTab;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  const t20 = `${activeTab === "Referral" ? "font-semibold text-[#52A1FF]" : "font-normal"}`;
  let t21;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Link href="/referral" onClick={_temp4}>Referral</Link>;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  let t22;
  if ($[28] !== t20) {
    t22 = <li className={t20}>{t21}</li>;
    $[28] = t20;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  const t23 = `${activeTab === "ResumeWriting" ? "font-semibold text-[#52A1FF]" : "font-normal"}`;
  let t24;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Link href="/resume-writing">Resume Writing</Link>;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  let t25;
  if ($[31] !== t23) {
    t25 = <li className={t23}>{t24}</li>;
    $[31] = t23;
    $[32] = t25;
  } else {
    t25 = $[32];
  }
  let t26;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <li className={"$ {\n              activeTab === \"Blogs\"\n                ? \"font-semibold text-[#52A1FF]\"\n                : \"font-normal\"\n            }"}><Link href="/blog">Blogs</Link></li>;
    $[33] = t26;
  } else {
    t26 = $[33];
  }
  let t27;
  if ($[34] !== t14 || $[35] !== t18 || $[36] !== t19 || $[37] !== t22 || $[38] !== t25) {
    t27 = <ul className="hidden gap-7 xl:gap-12 lg:flex">{t14}{t15}{t18}{t19}{t22}{t25}{t26}</ul>;
    $[34] = t14;
    $[35] = t18;
    $[36] = t19;
    $[37] = t22;
    $[38] = t25;
    $[39] = t27;
  } else {
    t27 = $[39];
  }
  const t28 = accessToken ? "Sign out" : "Sign in";
  let t29;
  if ($[40] !== handleAuthClick || $[41] !== t28) {
    t29 = <button className="btn-gradient hidden px-8 py-2 font-poppins text-base lg:block" onClick={handleAuthClick}>{t28}</button>;
    $[40] = handleAuthClick;
    $[41] = t28;
    $[42] = t29;
  } else {
    t29 = $[42];
  }
  let t30;
  if ($[43] !== t11 || $[44] !== t27 || $[45] !== t29) {
    t30 = <div className="relative flex h-10 w-full items-center justify-between">{t9}{t11}{t27}{t29}</div>;
    $[43] = t11;
    $[44] = t27;
    $[45] = t29;
    $[46] = t30;
  } else {
    t30 = $[46];
  }
  const t31 = isMobileNavVisible ? "translate-x-0" : "translate-x-[150%]";
  let t32;
  if ($[47] !== t31) {
    t32 = cx("absolute right-0 top-5 transition-transform duration-500", t31);
    $[47] = t31;
    $[48] = t32;
  } else {
    t32 = $[48];
  }
  let t33;
  if ($[49] !== accessToken || $[50] !== handleAuthClick) {
    t33 = <MobileNavbar onClose={handleCloseMobileNav} handleAuthClick={handleAuthClick} accessToken={accessToken} />;
    $[49] = accessToken;
    $[50] = handleAuthClick;
    $[51] = t33;
  } else {
    t33 = $[51];
  }
  let t34;
  if ($[52] !== t32 || $[53] !== t33) {
    t34 = <div className={t32}>{t33}</div>;
    $[52] = t32;
    $[53] = t33;
    $[54] = t34;
  } else {
    t34 = $[54];
  }
  let t35;
  if ($[55] !== t30 || $[56] !== t34) {
    t35 = <header aria-label="Site Header" className={t5}>{t30}{t34}</header>;
    $[55] = t30;
    $[56] = t34;
    $[57] = t35;
  } else {
    t35 = $[57];
  }
  return t35;
};
function _temp(e) {
  e.preventDefault();
  window.location.href = "/upload-resume";
}
function _temp2() {
  return trackReferralNavHome();
}
function _temp3(e) {
  e.preventDefault();
  window.location.href = "/upload-resume";
}
function _temp4() {
  return trackReferralNavHome();
}